export default __webpack_public_path__ + "static/media/halas15.0aaf4617.jpg";